/** Dev-only: set REACT_APP_SKIP_AUTH=true in `.env.local`. Never enable in production builds (CRA inlines at build time). */
export const skipAuth = process.env.REACT_APP_SKIP_AUTH === 'true';

// Set REACT_APP_MSAL_REDIRECT_TRAILING_SLASH=true in .env.local to send
// http://localhost:3000/ instead of http://localhost:3000 (for Azure redirect URI testing).
const redirectUri =
  process.env.REACT_APP_MSAL_REDIRECT_TRAILING_SLASH === 'true'
    ? `${window.location.origin}/`
    : window.location.origin;

export const msalConfig = {
  auth: {
    clientId: "5b87c47f-343c-4c29-97ca-758161f86794",
    authority: "https://login.microsoftonline.com/543eaf7b-7e0d-4076-a34d-1fc8cc20e5bb/", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri,
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
 scopes: ["User.Read"]
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me/",
    graphPhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value"
};
